<template>
  <modal @close="$emit('close')">
    <template slot="header">{{ $t('modals.password-recovery.title') }}</template>

    <template slot="body">
      <form @submit.prevent="restore">
        <input class="hidden" type="submit" />
        <div class="form-element">
          <label for="password-recovery-email">E-mail</label>
          <input id="password-recovery-email" type="text" v-model="email" v-on:keyup="clearMessages" />
        </div>
      </form>
      <div class="red-color" v-html="error" />
      <div class="green-color" v-html="success" />
    </template>

    <template slot="footer">
      <color-button round color="yellow" @click="restore">{{ $t('modals.password-recovery.submit') }}</color-button>
      <div class="back-link">
        <span class="link" @click="back">{{ $t('common.go-back') }}</span>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '@/components/modals/Modal'
import ColorButton from '@/components/buttons/ColorButton'
import AuthenticationService from '@/services/AuthenticationService'

export default {
  components: {
    Modal,
    ColorButton
  },
  data () {
    return {
      email: '',
      error: null,
      success: null
    }
  },
  methods: {
    clearMessages () {
      this.error = null
      this.success = null
    },
    async restore () {
      this.error = null
      this.success = null
      try {
        const response = await AuthenticationService.restore({
          email: this.email
        })
        this.email = ''
        this.success = response.data.success
      } catch (error) {
        this.error = error.response.data.error
      }
    },
    back () {
      this.$emit('close')
      this.$store.commit('SHOW_MODAL', 'LOGIN')
    }
  }
}
</script>

<style scoped>
.back-link { align-items: center; display: flex; height: 30px; margin-left: 10px; }
</style>



// WEBPACK FOOTER //
// src/components/modals/PasswordRecovery.vue